import styled from 'styled-components';
import { Box } from '../../../../utils/style/extendable';
import { LinkProps } from '@reach/router';
import {
  black,
  blue,
  boxShadow1,
  lightBlue,
} from '../../../../utils/style/colors';

export const Item = styled(Box)<LinkProps<any>>`
  flex: none;
  color: ${blue};
  display: flex;
  transition: all 0.3s ease;
  align-items: center;
  margin-bottom: 1.5em;
  justify-content: flex-start;
  background-color: #f4f5f7;
  width: 200px;
  height: 200px;
  flex-direction: column;
  margin: 2em 2em 2em 0em;
  padding: 0;
  :hover {
    background-color: #dcdcdc;
  }
`;

export const ItemsList = styled('div')`
  flex: none;
  display: flex;
  flex-direction: row;
  height: auto;
  overflow: scroll;
  ::after {
    content: '';
    flex: 0 0 2em;
  }
`;
export const CardHeader = styled('span')`
  flex: none;
  color: gray;
  margin-right: 2rem;
  display: block;
  margin-top: 1.5em;
  font-weight: 500;
  align-items: center;
  justify-content: center;
`;

export const Card = styled('div')`
  margin-top: 1em;
  height: fit-content;
  // padding: 1em;
  display: flex;
  background: transparent;
  // box-shadow: 0 3px 20px 0px rgba(0, 0, 0, 0.1);
  // border-radius: 10px;
  flex-direction: column;
  @media only screen and (max-width: 769px) {
    flex: none;
  }
`;

export const ItemName = styled('span')`
  word-break: break-word;
  font-weight: 300;
  text-align: right;
  padding: 0.5em;
  width: 100%;
`;

export const ItemImage = styled('img')`
  width: 100%;
  height: 70%;
  border-radius: 10px 10px 0px 0px;
  object-fit: cover;
`;

export const HeaderHome = styled('a')`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: ${black};
  cursor: pointer;
`;
export const TwoLevelHeaderContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
`;
export const TwoLevelHeader = styled('span')`
  margin: auto;
  font-style: normal;
  font-weight: normal;
  width: 100%;
  text-align: center;
  font-size: 14px;
  display: block;
  line-height: 24px;
  margin: 1.5rem 0;
  font-size: 20px;
`;

export const Header = styled.div`
  margin: 10px;
`;

export const ChatbotContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 130px);
  margin-top: 1rem;
  gap: 2rem;
  padding: 0 2rem;
`;

export const ChatbotCard = styled.div`
  height: 100%;
  text-align: center;
  background: ${lightBlue};
  box-shadow: ${boxShadow1};
  border-radius: 1rem;
  margin: 0 0.5rem;
`;

export const ChatbotCardHeader = styled.header`
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChatbotCardBody = styled.main`
  height: 120px;
`;
